module.exports = (__webpack_public_path__ || '') + "static/images/RuStoreText-adeef037d09044bd22be5b2c947dc375.svg";